import { useEffect, useContext } from 'react'
import { createUseStyles } from 'react-jss'
import { Context as LoadingContext } from '@/context/loading'
import style from './style'

const useStyles = createUseStyles(style)

const NotFound = () => {
  const classes = useStyles()
  const { setReady } = useContext(LoadingContext)

  useEffect(() => {
    setReady(true)
  }, [])

  return (
    <div className={`page page404 ${classes.root}`}>
      <h2 className={classes.title}>404</h2>
    </div>
  )
}

export default NotFound
